import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { PropertyNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addProperty = (state: SyfoAppState, action: PayloadAction<PropertyNode>) => {
  if (state.currentVault) {
    state.currentVault.data.properties.push(action.payload);
  }
};

export const updateProperty = (state: SyfoAppState, action: PayloadAction<{ id: string; property: Partial<PropertyNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.properties, action.payload.id, action.payload.property);
  }
};

export const removeProperty = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.properties = state.currentVault.data.properties.filter(p => p.id !== action.payload);
  }
};